import { UserFields } from '@models/next/User';
import { z } from 'zod';

export const DeliveryRequestSubmitter = z.object({
  id: UserFields.shape.id,
  last_name: UserFields.shape.last_name,
  first_name: UserFields.shape.first_name,
  fullname: z.string(),
});

export type DeliveryRequestSubmitter = z.infer<typeof DeliveryRequestSubmitter>;

export const DeliveryRequestStatusName = z.enum([
  '配車依頼書作成済',
  '配車リンク作成済',
  'メール送信済未読',
  'メール送信済既読',
  'CSV送信済',
  '横持ち送信済',
  '配車完了',
]);

export type DeliveryRequestStatusName = z.infer<typeof DeliveryRequestStatusName>;

export const DeliveryRequestStatus = z.object({
  name: DeliveryRequestStatusName,
  time: z.string(),
  submitter: DeliveryRequestSubmitter.nullable(),
});

export type DeliveryRequestStatus = z.infer<typeof DeliveryRequestStatus>;
